import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import Vuex from 'vuex'


const store = () => new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
})

export default store